<template>
  <Transition name="welcome-fade">
    <div class="welcome-wrap" v-if="show">
      <div class="welcome-card">

        <!-- Header -->
        <div class="welcome-header">
          <div class="welcome-header-left">
            <div class="welcome-avatar">
              <span class="material-symbols-outlined">waving_hand</span>
            </div>
            <div>
              <p class="welcome-title">¡Bienvenido, {{ nombreUsuario }}!</p>
              <p class="welcome-subtitulo">Sistema de gestión de atenciones ambulatorias</p>
            </div>
          </div>
          <button class="welcome-close" @click="closePopup" title="Cerrar">
            <span class="material-symbols-outlined" style="font-size:18px">close</span>
          </button>
        </div>

        <!-- Cuerpo -->
        <div class="welcome-body">
          <p class="welcome-intro">Para comenzar, te recomendamos seguir estos pasos:</p>

          <div class="welcome-steps">
<!--
            <router-link
              class="welcome-step"
              :to="`/usuarioresumenform/${p_idUsuario}`"
              @click="closePopup"
            >
              <div class="step-icon step-icon--blue">
                <span class="material-symbols-outlined">manage_accounts</span>
              </div>
              <div class="step-info">
                <span class="step-titulo">Revisa tu perfil de usuario</span>
                <span class="step-desc">Verifica que tus datos de acceso estén actualizados.</span>
              </div>
              <span class="material-symbols-outlined step-arrow">chevron_right</span>
            </router-link>
            <router-link
              class="welcome-step"
              :to="`/personaform/${p_idPersona}`"
              @click="closePopup"
            >
              <div class="step-icon step-icon--green">
                <span class="material-symbols-outlined">person</span>
              </div>
              <div class="step-info">
                <span class="step-titulo">Configura tu información personal</span>
                <span class="step-desc">Completa tus datos para un servicio más personalizado.</span>
              </div>
              <span class="material-symbols-outlined step-arrow">chevron_right</span>
            </router-link>
-->
            <router-link
              class="welcome-step"
              to="/faq"
              @click="closePopup"
            >
              <div class="step-icon step-icon--amber">
                <span class="material-symbols-outlined">help</span>
              </div>
              <div class="step-info">
                <span class="step-titulo">Revisa las preguntas frecuentes</span>
                <span class="step-desc">Encuentra respuestas rápidas sobre el uso del sistema.</span>
              </div>
              <span class="material-symbols-outlined step-arrow">chevron_right</span>
            </router-link>
          </div>
        </div>

        <!-- Footer -->
        <div class="welcome-footer">
          <label class="welcome-check">
            <input type="checkbox" v-model="noVolver">
            No mostrar de nuevo
          </label>
          <button class="btn btn-primary btn-sm" @click="closePopup">
            Entendido
          </button>
        </div>

      </div>
    </div>
  </Transition>
</template>

<script>
import api from "@/services/api";

export default {
  name: 'Welcome',
  props: {
    show: { type: Boolean, required: true },
  },
  data() {
    return {
      p_idPersona:   0,
      p_idUsuario:   0,
      nombreUsuario: '',
      noVolver:      false,
      valor: 0,
    }
  },
  mounted() {
    this.p_idPersona   = window.sessionStorage.getItem('idPersona')
    this.p_idUsuario   = window.sessionStorage.getItem('idUsuario')
    this.nombreUsuario = window.sessionStorage.getItem('usuario') ?? 'Usuario'
    if(window.sessionStorage.getItem("bienvenida") == 1)
      this.noVolver = true;
	else
      this.noVolver = false;
  },
  methods: {
    async closePopup() {      
/*	
      if (this.noVolver) {
        window.localStorage.setItem('welcomeVisto', '1')
      }
*/
      if(this.noVolver == true)
        this.valor = 1;
      else
        this.valor = 0;
      await api.patch(`/usuarios/${this.p_idUsuario}/bienvenida`, null, {
        params: { valor: this.valor }
      })
      window.sessionStorage.setItem("bienvenida", this.valor)
      this.$emit('update:show', false)
    },
  },
}
</script>

<style scoped>
.welcome-fade-enter-active,
.welcome-fade-leave-active { transition: opacity .3s, transform .3s; }
.welcome-fade-enter-from,
.welcome-fade-leave-to     { opacity: 0; transform: translateY(-8px); }

.welcome-wrap { margin: 12px 0 16px; }

.welcome-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,.08);
  overflow: hidden;
}

.welcome-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: linear-gradient(135deg, #185FA5 0%, #0C447C 100%);
}
.welcome-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.welcome-avatar {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255,255,255,.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.welcome-avatar .material-symbols-outlined { font-size: 22px; color: #fff; }
.welcome-title    { font-size: .95rem; font-weight: 600; color: #fff; margin: 0 0 2px; }
.welcome-subtitulo { font-size: .75rem; color: rgba(255,255,255,.75); margin: 0; }
.welcome-close {
  background: rgba(255,255,255,.15);
  border: none;
  border-radius: 6px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  flex-shrink: 0;
  transition: background .15s;
}
.welcome-close:hover { background: rgba(255,255,255,.3); }

.welcome-body   { padding: 16px; }
.welcome-intro  { font-size: .825rem; color: #6c757d; margin: 0 0 12px; }

.welcome-steps  { display: flex; flex-direction: column; gap: 8px; }
.welcome-step {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #fafafa;
  text-decoration: none;
  color: inherit;
  transition: background .15s, border-color .15s;
}
.welcome-step:hover {
  background: #f0f4ff;
  border-color: #B5D4F4;
  color: inherit;
  text-decoration: none;
}
.step-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.step-icon .material-symbols-outlined { font-size: 18px; }
.step-icon--blue  { background: #E6F1FB; }
.step-icon--blue  .material-symbols-outlined { color: #185FA5; }
.step-icon--green { background: #D1FAE5; }
.step-icon--green .material-symbols-outlined { color: #065F46; }
.step-icon--amber { background: #FEF3C7; }
.step-icon--amber .material-symbols-outlined { color: #92400E; }

.step-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.step-titulo { font-size: .875rem; font-weight: 500; color: #212529; }
.step-desc   { font-size: .775rem; color: #6c757d; }
.step-arrow  { font-size: 18px; color: #9aa0ac; flex-shrink: 0; }

.welcome-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-top: 1px solid #f0f0f0;
  background: #f8f9fa;
}
.welcome-check {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: .8rem;
  color: #6c757d;
  cursor: pointer;
  margin: 0;
}
.welcome-check input { cursor: pointer; }
</style>